import { useFeatureFlag, useFeatureFlagsReady } from '@newfront-insurance/admin-ui';
import { useEffect } from 'react';

import { useNovaNavigation } from './nova-navigation-context';
import type { NovaView } from './types';
import { NOVA_SCHEDULES_FEATURE_FLAG } from '../../../lib/nova-schedule-proposal';
import { useCanViewNovaAnalytics } from '../hooks/use-can-view-nova-analytics';

export function NovaNavigationCanonicalizer({ returnToChat }: { returnToChat: Extract<NovaView, { kind: 'chat' }> }) {
  const { view, actions } = useNovaNavigation();
  const ready = useFeatureFlagsReady();
  const skillsEnabled = useFeatureFlag('nova-skills', false);
  const managementEnabled = useFeatureFlag('nova-skills-management', false);
  const schedulesEnabled = useFeatureFlag(NOVA_SCHEDULES_FEATURE_FLAG, false);
  const analyticsEnabled = useCanViewNovaAnalytics();
  useEffect(() => {
    if (!ready) return;
    if (view.kind === 'scheduled' && !schedulesEnabled) actions.canonicalize(returnToChat);
    if (view.kind !== 'settings') return;
    if ((view.section === 'skills' && !skillsEnabled) || (view.section === 'analytics' && !analyticsEnabled)) {
      actions.canonicalize({ kind: 'settings', section: 'general' });
    } else if (view.section === 'skills' && !managementEnabled) {
      actions.canonicalize({ ...view, subView: undefined, tab: view.tab === 'my-skills' ? 'wtw-skills' : view.tab });
    }
  }, [actions, analyticsEnabled, managementEnabled, ready, returnToChat, schedulesEnabled, skillsEnabled, view]);
  return null;
}
